/** @module csi/heading/TimeInPast */
define([
	"dojo/_base/declare",
	"csi/heading/TimeDateTime"
], function(declare,TimeDateTime) {

	return declare(TimeDateTime, {
		/**
		 * Specify that this time must be in the past so DateRange widget will present more targeted interface
		 * @param {Spec} spec
		 * @param {Object} [extraParams]
		 * @return {Object} - parameters for DateRange widget
		 */
		getDateRangeParams: function(spec, extraParams) {
			var params = this.inherited(arguments);
			params.popupParams.inPast = true;
			return params;
		}
	});
});